import React from 'react';
import { Form } from 'react-bootstrap';
import PublicationAssetActions from './PublicationAssetActions';

export default function PublicationAssetInput({ name, value, folder, label, onChange, error }) {
    const fileName = value instanceof File
        ? value.name
        : typeof value === 'string'
            ? value.trim().split(/[?#]/)[0].split('/').pop()
            : '';

    return (
        <div className="publication-upload-field">
            <div className="publication-upload-picker">
                <Form.Control
                    type="file"
                    name={name}
                    className="publication-upload-control"
                    onChange={onChange}
                    isInvalid={!!error}
                    required={!value}
                    aria-label={label + (fileName ? ': ' + fileName : '')}
                    title={fileName || 'Choose ' + label.toLowerCase()}
                />
                <div className="publication-upload-display" aria-hidden="true">
                    <span className="publication-upload-choose">Choose File</span>
                    <span className="publication-upload-filename">{fileName || 'No file chosen'}</span>
                </div>
                <Form.Control.Feedback type="invalid">
                    {error || 'Please select ' + label.toLowerCase()}
                </Form.Control.Feedback>
            </div>
            <PublicationAssetActions value={value} folder={folder} label={label} />
        </div>
    );
}
